var e = /* @__PURE__ */ ((r) => (r.Feature = "feature", r.Horizontal = "horizontal", r.Standard = "standard", r))(e || {}), a = /* @__PURE__ */ ((r) => (r.Body = "body", r.CallToAction = "callToAction", r.Footer = "footer", r.Header = "header", r.Media = "media", r.SubHeader = "subheader", r))(a || {});
export {
  e as CardVariant,
  a as SlotType
};
